export const PROJECT_STATUSES = {
  IS_ACTIVE: 'is_active',
  ON_HOLD: 'on_hold',
  COMPLETED: 'completed',
};
